package uz.ferro.erp.feature.appuser.model

import kotlinx.serialization.Serializable

@Serializable
data class UserPermissionDto(
    val id: Long?,

    val name: String,

    var isAllowed: Boolean
)